import React from "react";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { Card, CardContent, Typography } from "@mui/material";

const DescriptionCard: React.FC = () => {
    const { selectedIssue } = useCphDataContext();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    return (
        <Card sx={{ width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0 }}>
            <CardContent>
                <Typography variant="body2">
                    <strong>Issue:</strong>
                </Typography>
                <Typography variant="body2">
                    {selectedIssue.title}
                </Typography>
                <Typography variant="body2">
                    <strong>Description:</strong>
                </Typography>
                <Typography variant="body2">
                    {selectedIssue.description}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default DescriptionCard;
